import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import * as ProgressBars from 'rc-progress';

import Modal from 'react-responsive-modal';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('LOADING_SPINNER', LOG_LEVELS.ERROR);
class LoadingSpinner extends Component {
  render() {
    log.debug('render(): ', this.props);
    const strokeWidth = this.props.strokeWidth || 3;
    const trailWidth = this.props.trailWidth || 2;

    if(this.props.progressBarOnly ) {
      if(this.props.progressPercentage === false || Number.isNaN(this.props.progressPercentage)) {
        return (
          <div></div>
        );
      }
      return (
        <div className={this.props.show ? '': 'invisible'}>
            <ProgressBars.Line
              percent={this.props.progressPercentage}
              strokeColor={'#ffcba8'}
              strokeWidth={strokeWidth}
              trailWidth={trailWidth}
            />
        </div>    
      );
    }

    return (
      <Modal little
             open={this.props.loadingCount > 0}
             closeOnOverlayClick={false}
             closeOnEsc={false}
             showCloseIcon={false}
             onClose={()=>{}}
             container={this.props.container}
            //  classes={{
            //   modal: "Modal-modal-0-1-3 test"
            //   // Setting no classes on the modal removes the default white background class
            // }}
            classNames={{
              modal: "no-modal-bg"
              // Setting no classes on the modal removes the default white background class
            }}
      >
        {
          typeof this.props.progressPercentage  === 'number' ? (
            <ProgressBars.Line
              percent={this.props.progressPercentage}
              strokeColor={'#ffcba8'}
              strokeWidth={strokeWidth}
              trailWidth={trailWidth}
            />
            )
            :
            (<div></div>)
        }
        <s-loader size="lg" loading=""></s-loader>
      </Modal>
    );
  }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  let progressPercentage = false;
  const loadingCount = _.reduce(state, (count, subState) => {
    if (typeof subState !== 'object') {
      return count;
    }
    if (typeof subState?.loading !== 'boolean') {
      return count;
    }
    if (subState?.loading) {
      return count + 1;
    }
    return count;
  }, 0);
  const  progressGrandTotals = _.reduce(state, (grandTotals, subState) => {
    if (typeof subState !== 'object') {
      return grandTotals;
    }
    if (typeof subState?.progress !== 'object') {
      return grandTotals;
    }
    grandTotals.total += subState.progress.total || 0;
    grandTotals.count += subState.progress.count || 0;

    return grandTotals;
  }, {total: 0, count: 0});
  if (progressGrandTotals.total > 0) {
    progressPercentage = Math.round(100 * (progressGrandTotals.count / progressGrandTotals.total));
  }
  return {
    loadingCount,
    progressGrandTotals,
    progressPercentage,
  };
}


LoadingSpinner.defaultProps = {
  progressBarOnly: false,
  strokeWidth: 3,
  trailWidth: 2,
  show: true
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(LoadingSpinner);